import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Landing } from '@/domain/share/Landing';
import { getStagePrefix } from '@/utils/api';

export default function TransportCard() {
  const [ query ] = useSearchParams();
  const language = query.get('language') ?? 'ko';
  const code = query.get('code') ?? '';

  useEffect(() => {
    const stage = getStagePrefix();
  
    // 1) 내부로 들어갈 실제 웹뷰 URL을 "정상 문자열"로 먼저 만든다.
    const innerUrl =
      `https://${stage}app.static.swingmobility.dev` +
      `/go/membership/store/transport-card` +
      `?language=${encodeURIComponent(language)}` +
      `&code=${encodeURIComponent(code)}`;
  
    // 2) AppsFlyer deeplink(wv?url=...)에서 url 값만 인코딩한다. (한 번만!)
    const encodedInnerUrl = encodeURIComponent(innerUrl);
  
    const wv = `theswing://wv?url=${encodedInnerUrl}`;
    const encodedWv = encodeURIComponent(wv); // deep_link_value / af_dp 값은 통째로 인코딩해주는 게 안전
  
    const link =
      `https://theswing.onelink.me/bDAE` +
      `?af_xp=text` +
      `&pid=SMS` +
      `&is_retargeting=true` +
      `&af_reengagement_window=1h` +
      `&af_force_deeplink=true` +
      `&deep_link_value=${encodedWv}` +
      `&af_dp=${encodedWv}`;
  
    const t = window.setTimeout(() => {
      window.location.href = link;
    }, 400);
  
    return () => window.clearTimeout(t);
  }, []);

  return <Landing />;
}